import React from 'react';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

const FacebookLoginButton = ({ onLoginSuccess }) => {
  const navigate = useNavigate();

  const responseFacebook = (response) => {
    if (response.status === 'unknown') {
      console.log('User cancelled login or did not fully authorize.');
    } else {
      console.log('Login Successful:', response);
  
      const accessToken = response.accessToken || response.authResponse?.accessToken;
      if (!accessToken) {
        console.error('Access Token not found');
        return;
      }
  
      localStorage.setItem('accessToken', accessToken); // Store accessToken in localStorage
  
      fetch(`https://graph.facebook.com/me?fields=id,name,email,picture&access_token=${accessToken}`)
        .then((res) => res.json())
        .then((userInfo) => {
          console.log(userInfo, 'userInfo');
          localStorage.setItem('user', JSON.stringify(userInfo));
  
          if (onLoginSuccess) {
            onLoginSuccess(userInfo);
          }
  
          $("#profileModal").hide();
          $(".modal-backdrop").remove();
          $('body').removeClass('modal-open');
          $('body').css('padding-right', '0px');
          $('body').css('overflow', 'auto');
          navigate('/');
        })
        .catch((err) => console.error('Error fetching user data:', err));
    }
  };
  

  return (
      // <FacebookLogin
      //   appId='3136931703120919'
      //   autoLoad={false}
      //   fields="name,email,picture"
      //   scope="public_profile,email"
      //   callback={responseFacebook}
      //   icon="fa-facebook"
      //   textButton="Facebook"
      // />
       <FacebookLogin
      appId='3136931703120919'
      autoLoad={false}
      fields="name,email,picture"
      scope="public_profile,email"
      callback={responseFacebook}
      render={renderProps => (
        <button
          onClick={renderProps.onClick}
          className="btn login-option facebook"
        >
          <svg className='pe-3' width={'2.5rem'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"/></svg>
           Facebook
        </button>
      )}
    />
  );
};

export default FacebookLoginButton;
